import { customLogger } from "@/utils";
const specs = require("@/specs").default;
const store = require("@/store").default;
const axios = require("axios");

//#region Lexception
function getProductIdFromUrl(url) {
    try {
        // Regular expression to match the product ID in the URL
        var regex = /\/(\d+)\//;
        // Match the URL against the regex
        var match = url.match(regex);
        // If a match is found, return the product ID
        if (match && match[1]) {
            return match[1];
        } else {
            // If no match found, throw an error
            throw new Error("Product ID not found in URL");
        }
    } catch (error) {
        // Handle the error
        customLogger("Error:", error.message);
        // You can return null or throw the error further depending on your requirement
        return null;
    }
}

const getProductsFromBrandApi = async (url) => {
    try {
        var productId = getProductIdFromUrl(url);

        if (!productId) throw new Error("Product ID not found in URL");

        const { data } = await axios.get(
            `https://www.lexception.com/fr-fr/template/article/${productId}`
        );

        let gender = "unisex";
        if (data.pour_femme === 1 && data.pour_homme === 0) {
            gender = "female";
        } else if (data.pour_femme === 0 && data.pour_homme === 1) {
            gender = "male";
        } else {
            gender = "unisex";
        }

        const productData = {
            id: `${data.id}`,
            fr_name: data.nom_fr,
            en_name: data.nom_en,
            brand: data.url_rewrite_crea,
            category_fr: data.subactivity_fr,
            category_en: data.subactivity_en,
            price: data.prix,
            gender,
        };

        return productData;
    } catch (e) {
        customLogger(e);
    }
};

const initializeCleedSizeRecoLException = async (productData) => {
    // Adapter le nom au client
    const cleed_size_reco_lexception = document.getElementById(
        specs._PRODUCT_FORM_NAME
    ); // Adapter le nom au client
    const style =
        "font-weight: bold; padding: 4px 8px; border-radius: 4px;color: black;";
    if (cleed_size_reco_lexception) {
        try {
            const product = await store.dispatch("FETCH_LEX_VERIFY_PRODUCT", {
                dataLayerContent: productData,
            });
            if (!product?.data) {
                throw new Error("Product not found");
            }
            customLogger("%cProduct found", `${style}background-color: green`);
            cleed_size_reco_lexception.innerHTML =
                store.state.user.lang === "fr"
                    ? "Quelle est ma taille ?"
                    : "What is my size?";
            //  add cursor pointer
            cleed_size_reco_lexception.style.cursor = "pointer";
            // change the color
            cleed_size_reco_lexception.style.color =
                specs._SIZE_ADVICE_BUTTON_TEXT_COLOR;

            const parentElement = cleed_size_reco_lexception.parentNode;
            const body = document.querySelector("body");
            let shouldRemoveDrawerClass = false;
            const parentObserver = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    if (
                        mutation.type === "attributes" &&
                        mutation.attributeName === "class" &&
                        parentElement.classList.contains("open")
                    ) {
                        parentElement.classList.remove("open");
                    }
                }
            });
            parentObserver.observe(parentElement, { attributes: true });
            const bodyObserver = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    if (
                        shouldRemoveDrawerClass &&
                        mutation.type === "attributes" &&
                        mutation.attributeName === "class" &&
                        body.classList.contains("drawer-open")
                    ) {
                        body.classList.remove("drawer-open");
                        shouldRemoveDrawerClass = false;
                    }
                }
            });
            bodyObserver.observe(body, { attributes: true });
            cleed_size_reco_lexception.onclick = () => {
                customLogger(
                    "%cButton clicked",
                    `${style}background-color: blue`
                );
                store.state.user.modal_reco_sizeModal = true;
                shouldRemoveDrawerClass = true;
            };
        } catch (e) {
            customLogger(e);
            customLogger(
                "%cProduct not found",
                `${style}background-color: red`
            );
            cleed_size_reco_lexception.style.display = "none";
        }
    } else {
        customLogger("%cButton not found id", `${style}background-color: red`);
    }
};

async function lexSizeAdviceInit() {
    try {
        let url;
        const urls_examples = [
            "https://www.lexception.com/fr-fr/164358/adidas-samba-og-cloud-blanc-adidas",
            "https://www.lexception.com/fr-fr/150557/boots-highwood-mink-birkenstock",
            "https://www.lexception.com/fr-fr/150625/basket-tropez-daim_militaire-philippemodel",
            "https://www.lexception.com/fr-fr/167150/mocassins-type-182-noir-adieu",
            "https://www.lexception.com/fr-fr/167153/derbies-type-202-noir-adieu",
            "https://www.lexception.com/fr-fr/167152/sandales-type-140-moka-adieu",
            "https://www.lexception.com/fr-fr/167151/mocassins-type-203-noir-adieu",
            "https://www.lexception.com/fr-fr/167148/bottes-chelsea-type-191-ivoire-adieu",
            "https://www.lexception.com/fr-fr/167149/derbies-type-132-rose-pale-adieu",
            "https://www.lexception.com/fr-fr/150556/boots-highwood-mocca-birkenstock",
            "https://www.lexception.com/fr-fr/150559/mules-boston-wo-anthrazit-birkenstock",
            "https://www.lexception.com/fr-fr/167147/derbies-type-124-ambre-adieu",
        ];
        if (
            process.env.NODE_ENV === "development" ||
            process.env.NODE_ENV === "staging"
        ) {
            url =
                urls_examples[Math.floor(Math.random() * urls_examples.length)];
            var selectorManfield = document.querySelector("body");
            var buttonLEX = document.createElement("BUTTON");
            buttonLEX.id = specs._PRODUCT_FORM_NAME;
            buttonLEX.innerHTML =
                store.state.user.lang === "fr"
                    ? "Quelle est ma taille ?"
                    : "What is my size?";
            buttonLEX.style.padding = "20px";
            buttonLEX.style.border = "none";
            buttonLEX.style.fontSize = "16px";
            buttonLEX.style.cursor = "pointer";
            buttonLEX.style.minHeight = "50px";
            buttonLEX.style.padding = "5px 15px";
            buttonLEX.style.textAlign = "center";
            buttonLEX.style.borderRadius = "2px";
            buttonLEX.style.backgroundColor = "rgb(0, 0, 0)";
            buttonLEX.style.color = "rgb(255, 255, 255)";
            buttonLEX.style.textTransform = "uppercase";
            buttonLEX.onclick = function () {
                store.state.user.modal_reco_sizeModal = true;
            };
            selectorManfield.appendChild(buttonLEX);
        } else {
            url = window.location.href;
        }
        const product = await getProductsFromBrandApi(url);
        if (!product) {
            throw new Error("Product not found");
        }
        window.cleedDataLayer = product;
        await initializeCleedSizeRecoLException(product);
        
    } catch (e) {
        customLogger("error: ", e);
    }
}
//#endregion

//#region Manfield
const initializeCleedSizeRecoManfield = async () => {
    if (!window.dataLayer.length) throw "window.dataLayer is not defined";
    const cleed_size_reco_manfield = document.getElementById(
        "cleed_size_reco_manfield"
    );
    const style =
        "font-weight: bold; padding: 4px 8px; border-radius: 4px;color: white;";

    if (cleed_size_reco_manfield) {
        //  add cursor pointer
        cleed_size_reco_manfield.style.cursor = "pointer";

        try {
            if (!specs._DATALAYER_PATH) {
                throw new Error("Datalayer path not found");
            }
            var currentDL = eval(specs._DATALAYER_PATH);

            const product = await store.dispatch(
                "FETCH_MANFIELD_VERIFY_PRODUCT",
                {
                    dataLayerContent: currentDL,
                }
            );

            if (!product?.data) {
                throw new Error("Product not found");
            }
            customLogger("%cProduct found", `${style}background-color: green`);

            const parentElement = cleed_size_reco_manfield.parentNode;
            const body = document.querySelector("body");

            let shouldRemoveDrawerClass = false;

            const parentObserver = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    if (
                        mutation.type === "attributes" &&
                        mutation.attributeName === "class" &&
                        parentElement.classList.contains("open")
                    ) {
                        parentElement.classList.remove("open");
                    }
                }
            });

            parentObserver.observe(parentElement, { attributes: true });

            const bodyObserver = new MutationObserver((mutationsList) => {
                for (let mutation of mutationsList) {
                    if (
                        shouldRemoveDrawerClass &&
                        mutation.type === "attributes" &&
                        mutation.attributeName === "class" &&
                        body.classList.contains("drawer-open")
                    ) {
                        body.classList.remove("drawer-open");
                        shouldRemoveDrawerClass = false;
                    }
                }
            });

            bodyObserver.observe(body, { attributes: true });

            cleed_size_reco_manfield.onclick = () => {
                customLogger(
                    "%cButton clicked",
                    `${style}background-color: blue`
                );
                store.state.user.modal_reco_sizeModal = true;
                shouldRemoveDrawerClass = true;
            };
        } catch (e) {
            customLogger(
                `%c error: ${e.message}`,
                `${style}background-color: red`
            );
        }
    } else {
        customLogger("%cButton not found", `${style}background-color: red`);
    }
};

const manfieldSizeAdviceInit = async () => {
    try {
        // show datalayer
        if (
            process.env.NODE_ENV === "development" ||
            process.env.NODE_ENV === "staging"
        ) {
            const datalayerIndex = specs._DEV_MODE_DATALAYER_INDEX;
            if (!window.dataLayer) {
                window.dataLayer = [];
            }

            if (!window.dataLayer[datalayerIndex]) {
                window.dataLayer[datalayerIndex] = {};
            }

            if (!window.dataLayer[datalayerIndex]["ecommerce"]) {
                window.dataLayer[datalayerIndex]["ecommerce"] = {};
            }

            if (!window.dataLayer[datalayerIndex]["ecommerce"]["detail"]) {
                window.dataLayer[datalayerIndex]["ecommerce"]["detail"] = {};
            }
            window.dataLayer[datalayerIndex]["ecommerce"]["detail"][
                "products"
            ] = [];

            window.dataLayer[datalayerIndex]["ecommerce"]["detail"][
                "products"
            ][0] = {
                brand: "Bowen",
                category: "Derbies",
                couleur: "Cuir Marron fonce",
                id: "3192769",
                last: "BT10+",
                name: "DERBY DAVENPORT SANGLIER MARRON",
                parentCategory: "Derbies & Richelieu",
                price: "345",
                variant: "1BO22-61-530",
            };
            var selectorManfield = document.querySelector("body");
            var buttonManfield = document.createElement("BUTTON");
            var btn = document.getElementById("product-addtocart-button");
            buttonManfield.innerHTML =
                store.state.user.lang === "fr"
                    ? "Quelle est ma taille ?"
                    : "What is my size?";
            buttonManfield.id = "cleed_size_reco_manfield";
            buttonManfield.style.padding = "20px";
            buttonManfield.style.border = "none";
            buttonManfield.style.fontSize = "16px";
            buttonManfield.style.cursor = "pointer";
            buttonManfield.style.minHeight = "50px";
            buttonManfield.style.padding = "5px 15px";
            buttonManfield.style.textAlign = "center";
            buttonManfield.style.borderRadius = "2px";
            buttonManfield.style.backgroundColor = "rgb(0, 0, 0)";
            buttonManfield.style.color = "rgb(255, 255, 255)";
            buttonManfield.style.textTransform = "uppercase";
            btn.style = "display: none;";
            selectorManfield.appendChild(buttonManfield);
            await initializeCleedSizeRecoManfield();
        } else {
            // Callback function to be executed when a change is detected on class productFormClass
            const productFormClass = specs._PRODUCT_FORM_NAME;
            if (productFormClass && window.dataLayer) {
                customLogger("tracking product form class: ", productFormClass);
                const productFormMutationCallback = async function (
                    mutationsList,
                    observer
                ) {
                    for (const mutation of mutationsList) {
                        // Check if the mutation is related to the class
                        if (
                            mutation.target.classList.contains(
                                productFormClass
                            ) ||
                            Array.from(mutation.addedNodes).some((node) =>
                                node.classList?.contains(productFormClass)
                            )
                        ) {
                            customLogger(
                                `Changed detected on the class ${productFormClass}`
                            );
                            await initializeCleedSizeRecoManfield();
                        }
                    }
                };
                // Create an observer instance
                const observerProductFormClass = new MutationObserver(
                    productFormMutationCallback
                );
                // Configuration of the observer
                const config = {
                    attributes: true,
                    childList: true,
                    subtree: true,
                };
                // Start observing the entire HTML document
                observerProductFormClass.observe(
                    document.documentElement,
                    config
                );
            }
        }

        if (specs._RGDP_COOKIE_NAME) {
            // Call the function to initialize the cleed size reco only when the cookie is set to true (rbsWebsiteTrackerConsentGdpr)
            let intervalId = null;
            const checkCookieChange = async () => {
                const currentCookieValue = document.cookie;
                const hasRbsCookie = currentCookieValue.includes(
                    specs._RGDP_COOKIE_NAME
                );
                if (hasRbsCookie) {
                    customLogger("accept coockies: ", hasRbsCookie);
                    customLogger("setUp datalayers: ", window?.dataLayer);
                    await initializeCleedSizeRecoManfield();
                    clearInterval(intervalId);
                }
            };
            // Check for cookie changes every 1000 milliseconds (1 second)
            intervalId = setInterval(checkCookieChange, 1000);
        }
    } catch (e) {
        customLogger("error: ", e);
    }
};
//#endregion

export default {
    lexSizeAdviceInit,
    manfieldSizeAdviceInit,
};
